import validate from "/home/runner/work/1/s/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication_45global from "/home/runner/work/1/s/frontend/middleware/Authentication.global.ts";
import manifest_45route_45rule from "/home/runner/work/1/s/frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  authentication_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}